import { render, staticRenderFns } from "./AddReplyPopover.vue?vue&type=template&id=f885bfe2&scoped=true"
import script from "./AddReplyPopover.vue?vue&type=script&lang=js"
export * from "./AddReplyPopover.vue?vue&type=script&lang=js"
import style0 from "./AddReplyPopover.vue?vue&type=style&index=0&id=f885bfe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f885bfe2",
  null
  
)

export default component.exports